/* eslint-disable */
import React, { useState, useRef } from "react";
import { Modal, Divider, Button, Box, Text } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import { useDeleteApprovedLeave } from "api/newLeave/deleteApprovedLeave";

type DeleteApprovedLeaveProps = {
  opened: boolean;
  onClose: () => void;
  leaveId: string;
};

function DeleteApprovedLeaveModal({
  opened,
  onClose,
  leaveId,
}: DeleteApprovedLeaveProps) {
  const { mutate: deleteLeave, isLoading } = useDeleteApprovedLeave();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const formRef = useRef<HTMLFormElement | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (hasSubmitted || isLoading) return;
    setHasSubmitted(true);

    if (!leaveId) {
      console.error("Leave ID is missing");
      setHasSubmitted(false);
      return;
    }

    deleteLeave(leaveId, {
      onSuccess: (res: any) => {
        console.log("Leave deleted successfully:", res);
        setHasSubmitted(false);
        onClose();
      },
      onError: (err: any) => {
        console.error("Failed to delete leave:", err);
        setHasSubmitted(false);
        onClose();
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setHasSubmitted(false);
        onClose();
      }}
      size="md"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title="Delete Leave"
        onClose={onClose}
        ariaLabel="Close delete leave modal"
      />
      <Divider mb="md" />

      <Box
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Text
            size="sm"
            style={{
              fontWeight: 500,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Are you sure you want to delete this leave? If the leave was
            approved, the used days will be reverted back to the employee's
            balance.
          </Text>
        </Box>

        <Button
          type="submit"
          fullWidth
          loading={isLoading || hasSubmitted}
          color="red"
        >
          Yes, Delete Leave
        </Button>
        <Button
          variant="light"
          onClick={() => {
            setHasSubmitted(false);
            onClose();
          }}
          fullWidth
          disabled={isLoading}
        >
          No, Keep It
        </Button>
      </Box>
    </Modal>
  );
}

export default DeleteApprovedLeaveModal;
